import React from "react";
import classes from "./Banner.module.css";
import { useLocation } from "react-router-dom";

export const Banner = () => {
  const params = useLocation();

  return (
    <div className="row g-0">
      <div className={classes.bg_img}>
        <div className={classes.bg_color}>
          {params.pathname === "/about-us" && (
            <span className={`${classes.banner_text}`}>
              <h2 className="fw-bold text-light display-4">About Us</h2>
              <p className="text-light fs-5">Loans that bring your dream to life</p>
            </span>
          )}
          {params.pathname === "/terms-and-condition" && (
            <span className={`${classes.banner_text}`}>
              <h2 className="fw-bold text-light display-4">Terms and Conditions</h2>
              <p className="text-light fs-5">Welcome to www.dealsofarya.com Website (the "Site") maintained & <br/>operated by Deals of arya Finserv Consultants Private Limited (DOAFCPL). </p>
            </span>
          )}
          {params.pathname === "/privacy-policy" && (
            <span className={`${classes.banner_text}`}>
              <h2 className="fw-bold text-light display-4">Privacy Policy</h2>
              <p className="text-light fs-5">Deals of Arya Finserv Consultants Pvt.  Ltd. ("we", "our", or "us") values your privacy and is committed to safeguarding your personal information. <br/>This Privacy Policy outlines how we collect, use, share, and protect your data when you use our digital platforms.</p>
            </span>
          )}
          {params.pathname === "/services" && (
            <span className={`${classes.banner_text}`}>
              <h2 className="fw-bold text-light display-4">Our Services</h2>
              <p className="text-light fs-5">
                Meet all your financial requirements with our <br /> wide range
                of loans
              </p>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
